import * as React from "react";
import styled from "@emotion/styled";

import {ExpansionPanelReadMore, HideContactDataType, IHideContactDataScenarios} from "../../../../app/components/ExpansionPanelReadMore";
import {SectionBoxTitle} from "../SectionBoxTitle";

type IOwnProps = IHideContactDataScenarios & {
    description: string;
    subtitle: string;
    title: string;
    generatedDescription?: string;
};

export const Description = (props: IOwnProps) => {
    const {subtitle, description, title} = props;

    return (
        <>
            <SectionBoxTitle title={title} toggler={false} />

            <SubHeadline>{subtitle}</SubHeadline>

            {props.hideContactDataType === HideContactDataType.MASK ? (
                <ExpansionPanelReadMore
                    description={description}
                    descriptionJsx={props.generatedDescription ? <div dangerouslySetInnerHTML={{__html: props.generatedDescription}} /> : <></>}
                    offer={props.offer}
                    hideContactDataType={props.hideContactDataType}
                    gtmSource={props.gtmSource}
                />
            ) : (
                <ExpansionPanelReadMore
                    description={description}
                    descriptionJsx={props.generatedDescription ? <div dangerouslySetInnerHTML={{__html: props.generatedDescription}} /> : <></>}
                    hideContactDataType={props.hideContactDataType}
                />
            )}
        </>
    );
};

/*
Styles
 */

const SubHeadline = styled.h3`
    color: ${(props) => props.theme.colors.gray_dark};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.625;
`;
